import http from "../http-common";
import IFlightRange from "../types/FlightRanges";
import IModifyFlightRangeRequest from "../types/ModifyFlightRangeRequest";

export interface IActiveFlightRange {
  id: number;
  start: number;
  end: number;
  marketingCarrier: string;
  operatingCarrier: string;
  serviceType: string;
  flightType: string;
  flightTypeDescription: string;
  revManagedInd: string;
  effectiveDate: string;
  discontinueDate: string | null;
  modDate: string;
}

const getFlightRanges = (token?: string) => {
  return http.get<Array<IFlightRange>>('/api/FlightRange', {
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {}
  });
};

const getActiveFlightRanges = (token?: string) => {
  return http.get<IActiveFlightRange[]>('/api/FlightRange/active', {
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {}
  });
};

const modifyFlightRanges = (token?: string, requestBody?: IModifyFlightRangeRequest) => {
  return http.post<IModifyFlightRangeRequest>(
    '/api/FlightRange/modify',
    requestBody,
    {
      headers: token ? {
        Authorization: `Bearer ${token}`
      } : {}
    }
  );
};

const getFlightRangeHistory = (token?: string) => {
  return http.get<Array<IFlightRange>>(
    '/api/FlightRange/history',
    {
      headers: token ? {
        Authorization: `Bearer ${token}`
      } : {}
    }
  );
};

const FlightRangeService = {
  getFlightRanges,
  getActiveFlightRanges,
  modifyFlightRanges,
  getFlightRangeHistory
};

export default FlightRangeService;
